/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ seconds: NonNullable<unknown> }} Audio_Recorder_Pre_Roll_MaxInputs */



/**
* | output |
* | --- |
* | "(max: {seconds}s)" |
*
* @param {Audio_Recorder_Pre_Roll_MaxInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_recorder_pre_roll_max = /** @type {((inputs: Audio_Recorder_Pre_Roll_MaxInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Recorder_Pre_Roll_MaxInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`(max : ${i?.seconds}s)`)
	if (locale === "de") return /** @type {LocalizedString} */ (`(max: ${i?.seconds}s)`)
	if (locale === "it") return /** @type {LocalizedString} */ (`(massimo: ${i?.seconds}s)`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`(макс.: ${i?.seconds}s)`)
	if (locale === "es") return /** @type {LocalizedString} */ (`(máximo: ${i?.seconds}s)`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`（最大值：${i?.seconds}s）`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`(最大: ${i?.seconds} 秒)`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`(अधिकतम: ${i?.seconds}s)`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`(máx.: ${i?.seconds}s)`)
	return /** @type {LocalizedString} */ (`(max: ${i?.seconds}s)`)
});